import React from "react";
import Box from '@mui/material/Box';
import AssignmentIcon from '@mui/icons-material/Assignment';

import "./CardChartComponent.css";

function CardChartComponent({ title, subtitle, value, onIconClick, className = ''}) {
    const isClickable = typeof onIconClick === 'function';

    return (
        <div
            className={`card card-chart ${isClickable ? 'clickable' : ''} ${className}`}
            onClick={isClickable ? onIconClick : undefined}
        >
            <div className="card-chart-title-contaier">
                <Box>
                    <AssignmentIcon style={{ fontSize: '28px' }} />
                </Box>
                <div className="card-chart-title">{title}</div>
            </div>
            <div className="card-chart-value">{value}</div>
            <div className="card-chart-subtitle">{subtitle}</div>
        </div>
    );
}

export default CardChartComponent;
